// Whitelists.js
import React, { useState, useEffect } from "react";
import "react-multi-carousel/lib/styles.css";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import BoatHelm from "../../../../Asset/icon/boat_helm.svg";
import { getYachtInfoSellingPriceRatePlanListDetail } from "../../../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import { getYachtInfoAmenitiesDetail } from "../../../../redux/YachtInfoAmenities/YachtInfoAmenitiesSlice";
import { getYachtInfoWaterToyDetail } from "../../../../redux/YachtInfoWaterToy/YachtInfoWaterToySlice";
import { getYachtInfoGalleryDetail } from "../../../../redux/yachtInfoGallery/YachtInfoGallerySlice";
import { getYachtInfoDestinationPackageDetail } from "../../../../redux/yachtInfoDestinationPackage/YachtInfoDestinationPackageSlice";
import {
  getMarinaDetail,
  getProvinceDetail,
  getDestinationDetail,
} from "../../../../redux/centerData/CenterDataSlice";
import { getYachtDetail } from "../../../../redux/yacht/YachtSlice";
import {
  getUserDetail,
  sendEmailBookingAction,
} from "../../../../redux/Auth/AuthSlice";
import {
  getWhitelistAction,
  createNewBooking,
  getBookingHistoryDetail,
  getYachtAction,
} from "../../../../redux/booking/BookingSlice";
import { getYachtTypesDetail } from "../../../../redux/YachtTypes/YachtTypesSlice";
import { useTranslation } from "react-i18next";
import { FaMapMarkerAlt } from "react-icons/fa";
import "../../../../Asset/scss/takemyyacht.scss";
import Sail from "../../../../Asset/image/yacht/Sail.gif";
import { Pagination } from "react-bootstrap";
import dayjs from "dayjs";

const Whitelists = () => {
  const { t, i18n } = useTranslation();
  const selectedLanguage = localStorage.getItem("selectedLanguage");
  const { slug } = useParams();
  const navigate = useNavigate();
  const todos = useSelector((state) => state);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth?.token);
  const isAuth = useSelector((state) => state.auth?.isAuthenticated);
  const userDetails = useSelector((state) => state.AuthSlice.user);
  const getToken = useSelector((state) => state.AuthSlice.token);
  const [loading, setLoading] = useState(true);
  const whitelist = todos.Booking.whitelistResults?.data;
  const [openFormId, setOpenFormId] = useState(null);
  const marinaLookup = todos.CenterDataSlice.Marina?.results;
  const provinceLookup = todos.CenterDataSlice.Province?.results;
  const [currentPage, setCurrentPage] = useState(1);
  const yachtsPerPage = 5;

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  const showSnackbar = (message, severity = "error") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (isAuth && token) {
          await dispatch(getUserDetail({ token }));
        }
        await dispatch(getMarinaDetail());
        await dispatch(getProvinceDetail());
        await dispatch(getDestinationDetail());
        await dispatch(getYachtDetail());
        await dispatch(getWhitelistAction());
        await dispatch(getYachtAction());
        await dispatch(getYachtInfoGalleryDetail());
        await dispatch(getYachtInfoDestinationPackageDetail());
        await dispatch(getYachtInfoWaterToyDetail());
        await dispatch(getYachtInfoSellingPriceRatePlanListDetail());
        await dispatch(getYachtInfoAmenitiesDetail());
        await dispatch(getYachtTypesDetail());
        // await dispatch(getBookingHistoryDetail({ token }));
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // ปิด loading แน่นอน
      }
    };

    fetchData();
  }, [dispatch, token, isAuth]);

  const [today, setToday] = useState("");
  const [startDate, setStartDate] = useState("");

  useEffect(() => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    setToday(`${yyyy}-${mm}-${dd}`);
  }, []);

  const selectedYachts = whitelist?.filter(
    (whitelistItem) =>
      Number(whitelistItem?.idUserTMY) === Number(userDetails?.idUserTMY),
  );

  const sellingPricePlans =
    todos.YachtInfoSellingPriceRatePlanListSlice
      ?.YachtInfoSellingPriceRatePlanList?.results || [];

  const todays = new Date();

  const filteredYachts =
    selectedYachts?.length > 0
      ? sellingPricePlans.filter((yacht) => {
        // ✅ แปลงวันที่จาก "2025/10/16" เป็น "2025-10-16"
        const startDate = yacht.start_rate_plan_date
          ? new Date(yacht.start_rate_plan_date.replace(/\//g, "-"))
          : null;
        const endDate = yacht.end_rate_plan_date
          ? new Date(yacht.end_rate_plan_date.replace(/\//g, "-"))
          : null;

        // ✅ ตรวจสอบว่าปัจจุบันอยู่ในช่วงวันที่ใช้งานได้
        const isWithinDateRange =
          (!startDate || todays >= startDate) &&
          (!endDate || todays <= endDate);

        // ✅ กรองเฉพาะเรือที่อยู่ใน selectedYachts และอยู่ในช่วงวันที่เปิดใช้งาน
        return (
          selectedYachts.some(
            (selected) =>
              Number(yacht?.id_sellingPrice) ===
              Number(selected?.id_sellingPrice),
          ) && isWithinDateRange
        );
      })
      : [];

  const allYachts = todos.YachtSlice.Yacht?.results || [];
  const yachtMap = allYachts.reduce((acc, yacht) => {
    acc[yacht.id_yacht] = yacht;
    return acc;
  }, {});

  const allDestinationPackages =
    todos.YachtInfoDestinationPackageSlice.YachtInfoDestinationPackage
      ?.results || [];

  const handleToggleForm = (id) => {
    setOpenFormId(openFormId === id ? null : id);
  };

  function getLocalizedMarina(marinaValue) {
    if (!marinaValue || !marinaLookup || !provinceLookup) {
      return marinaValue;
    }

    // แยก pier ถ้ามี, format เป็น "pier / Marina, Province"
    let pierPart = "";
    let restPart = marinaValue;

    if (marinaValue.includes(" / ")) {
      [pierPart, restPart] = marinaValue.split(" / ").map((s) => s.trim());
    }

    const [marinaEn, provinceEn] = restPart.split(",").map((s) => s.trim());

    const marinaObj = marinaLookup.find((m) => m.name_marina_en === marinaEn);
    const provinceObj = provinceLookup.find(
      (p) => p.ProvinceEng === provinceEn,
    );

    if (i18n.language === "th") {
      const marinaTh = marinaObj?.name_marina_th || marinaEn;
      const provinceTh = provinceObj?.ProvinceThai || provinceEn;
      return pierPart
        ? `${pierPart} / ${marinaTh}, ${provinceTh}`
        : `${marinaTh}, ${provinceTh}`;
    }

    const marinaName = marinaObj?.name_marina_en || marinaEn;
    const provinceName = provinceObj?.ProvinceEng || provinceEn;
    return pierPart
      ? `${pierPart} / ${marinaName}, ${provinceName}`
      : `${marinaName}, ${provinceName}`;
  }

  const calcOvernightStay = (dateRange) => {
    if (!dateRange) return 0;

    const matches = String(dateRange).match(/(\d{4}[\/-]\d{1,2}[\/-]\d{1,2})/g);
    if (!matches || matches.length < 2) {
      const alt = String(dateRange)
        .split(/[,|;]/)
        .map((s) => s.trim())
        .filter(Boolean);
      if (alt.length >= 2) {
        const startAlt = dayjs(alt[0].replace(/-/g, "/").trim());
        const endAlt = dayjs(alt[1].replace(/-/g, "/").trim());
        if (startAlt.isValid() && endAlt.isValid()) {
          const nightsAlt = endAlt.diff(startAlt, "day");
          return nightsAlt > 0 ? nightsAlt : 0;
        }
      }
      return 0;
    }

    const start = dayjs(matches[0].replace(/-/g, "/").trim());
    const end = dayjs(matches[1].replace(/-/g, "/").trim());
    if (!start.isValid() || !end.isValid()) return 0;

    const nights = end.diff(start, "day");
    return nights > 0 ? nights : 0;
  };

  const handleSubmit = async (e, yacht) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    const adultCount = parseInt(formData.get("adult"), 10);
    const childCount = parseInt(formData.get("child"), 10);
    const infantCount = parseInt(formData.get("infant"), 10);
    const totalGuests = adultCount + childCount + infantCount;

    // ตรวจสอบจำนวนผู้โดยสาร
    let maxGuestsAllowed = 0;
    if (yacht.rate_type === "DayTrip" || yacht.rate_type === "HalfDay") {
      maxGuestsAllowed = yacht.guests_day;
    } else if (yacht.rate_type === "Overnight") {
      maxGuestsAllowed = yacht.guests_sleeping;
    }

    if (totalGuests > maxGuestsAllowed) {
      showSnackbar(
        t("guestsExceedLimit", { total: totalGuests, limit: maxGuestsAllowed }),
        "warning",
      );
      return;
    }

    // ฟังก์ชันแปลงวันที่
    const formatDates = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}/${month}/${day}`;
    };

    const formatDate = (dateStr) => {
      if (!dateStr) return "";
      const [year, month, day] = dateStr.split("-");
      return `${year}/${month}/${day}`;
    };

    // จัดการวันที่ activity
    let activity_date;
    let datesToCheck = [];

    if (yacht.rate_type === "Overnight") {
      const startDate = formData.get("activity_start_date");
      const endDate = formData.get("activity_end_date");
      const formattedStart = formatDate(startDate);
      const formattedEnd = formatDate(endDate);
      activity_date = `${formattedStart}, ${formattedEnd}`;

      const getDatesInRange = (startStr, endStr) => {
        const dates = [];
        let current = new Date(startStr);
        const end = new Date(endStr);
        while (current <= end) {
          dates.push(formatDates(new Date(current)));
          current.setDate(current.getDate() + 1);
        }
        return dates;
      };
      datesToCheck = getDatesInRange(formattedStart, formattedEnd);
    } else {
      const date = formData.get("activity_date");
      activity_date = formatDate(date);
      datesToCheck = [activity_date];
    }

    // ตรวจสอบการซ้ำของการจอง
    const existingBookings = todos?.Booking?.BookingHistroy?.results || [];
    const isDuplicate = existingBookings.some((booking) => {
      if (booking.status === "CANCELLED") return false;
      if (booking.id_yachtInfo !== yacht.id_yachtInfo
        // || booking.activity_type !== yacht.rate_type
      )
        return false;

      const bookedDates = booking.activity_date.split(",").map((d) => d.trim());
      let bookedDateRange =
        bookedDates.length === 2
          ? datesToCheck // จะคำนวณอีกที
          : [bookedDates[0]];

      if (bookedDates.length === 2) {
        const getDatesInRange = (startStr, endStr) => {
          const dates = [];
          let current = new Date(startStr);
          const end = new Date(endStr);
          while (current <= end) {
            dates.push(formatDates(new Date(current)));
            current.setDate(current.getDate() + 1);
          }
          return dates;
        };
        bookedDateRange = getDatesInRange(bookedDates[0], bookedDates[1]);
      }

      return datesToCheck.some((date) => bookedDateRange.includes(date));
    });

    if (isDuplicate) {
      showSnackbar(
        t(
          "This activity date has already been booked. Please select another date.",
        ),
        "warning",
      );
      return;
    }

    // ✅ ตรวจสอบว่า activity_date อยู่ในช่วง start_rate_plan_date - end_rate_plan_date
    const ratePlanList =
      todos?.YachtInfoSellingPriceRatePlanListSlice
        ?.YachtInfoSellingPriceRatePlanList?.results || [];

    // หา Rate Plan ที่ตรงกับ id_sellingPrice ของเรือ
    const matchedRatePlan = ratePlanList.find(
      (plan) => Number(plan.id_sellingPrice) === Number(yacht.id_sellingPrice),
    );

    if (matchedRatePlan) {
      const startDate = new Date(matchedRatePlan.start_rate_plan_date);
      const endDate = new Date(matchedRatePlan.end_rate_plan_date);

      // ตรวจสอบทุกวันที่จอง
      const invalidDate = datesToCheck.some((dateStr) => {
        const checkDate = new Date(dateStr);
        return checkDate < startDate || checkDate > endDate;
      });

      if (invalidDate) {
        showSnackbar(
          t(
            "The selected date is not available for this rate plan. Please choose another date.",
          ),
          "warning",
        );
        return;
      }
    }

    if (yacht.rate_type === "Overnight" && matchedRatePlan?.minimum_stay) {
      const dateParts = activity_date.split(",").map((d) => d.trim());

      if (dateParts.length !== 2) {
        showSnackbar(
          t(
            "Please select both check-in and check-out dates for an overnight booking.",
          ),
          "warning",
        );
        return;
      }

      const startStr = dateParts[0];
      const endStr = dateParts[1];

      const startDate = new Date(startStr);
      const endDate = new Date(endStr);

      // คำนวนจำนวนคืน
      const diffTime = endDate - startDate;
      const nights = diffTime / (1000 * 60 * 60 * 24);

      if (nights < matchedRatePlan.minimum_stay) {
        showSnackbar(
          t(
            `Minimum stay for this yacht is ${matchedRatePlan.minimum_stay} nights. Please extend your booking dates.`,
          ),
          "warning",
        );
        return;
      }
    }

    // ดึงข้อมูลเจ้าของเรือ และ vat
    const yachtOwnerData = todos?.Booking?.yachtResult?.data?.find(
      (y) => y.id_yacht === yacht.id_yacht,
    );
    const vat = yachtOwnerData?.vat; // 1 = รวม VAT, 0 = ไม่รวม VAT

    // คำนวณราคาพร้อม VAT
    let totalPrice = parseFloat(yacht.value_sellingPrice) || 0;
    if (vat === 1) {
      const vatRate = 0.07; // VAT 7%
      totalPrice = totalPrice * (1 + vatRate);
    }

    let overnightStayCount = 0;
    if (yacht.rate_type === "Overnight") {
      overnightStayCount = calcOvernightStay(activity_date);
    }

    // สร้าง bookingData
    const bookingData = {
      activity_date,
      adult: adultCount,
      child: childCount,
      infant: infantCount,
      sum_all_price: totalPrice.toFixed(2),
      status: "INQUIRY",
      id_customer_type: "0000000001",
      issued_date: formatDates(new Date()),
      guest_name: `${userDetails?.firstname || ""} ${userDetails?.lastname || ""
        }`,
      id_yachtInfo: yacht.id_yachtInfo,
      activity_type: yacht.rate_type,
      overnight_stay: overnightStayCount,
      // overnight_stay: yacht.rate_type === "Overnight" ? 1 : 0,
      yacht_name: yacht.name_yacht_yachtInfo,
      comment: "",
      id_yacht: yacht.id_yacht,
      email: userDetails?.email,
      firstName: userDetails?.firstname,
      lastName: userDetails?.lastname,
      mobileNo: userDetails?.mobile_no,
      idPassport: userDetails?.passport_id,
      birthDate: userDetails?.birth_date,
      id_country: userDetails?.country_id,
      id_nationality: userDetails?.nationality_id,
      gender: userDetails?.gender,
      sum_price: yacht.sum_price,
      sum_surcharge: yacht.sum_surcharge,
      id_destination_package: yacht.id_destination_package,
      id_ratePlanList: yacht.id_ratePlanList,
      id_sellingPrice: yacht.id_sellingPrice,
      type_sellingPrice: yacht.type_sellingPrice,
      value_sellingPrice: yacht.value_sellingPrice,
      name_ratePlan: yacht.name_ratePlan,
      id_ratePlan: yacht.id_ratePlan,
    };

    try {
      const result = await dispatch(createNewBooking(bookingData));
      if (result.status) {
        showSnackbar(t("Booking created successfully!"), "success");
        form.reset();
        setOpenFormId(null);

        const idBooking = result.bookingId;
        const BookingNo = result.bookingNo;

        const yachtOwnerEmail = yachtOwnerData?.email;

        if (!yachtOwnerEmail) {
          console.warn("Yacht owner's email not found.");
          return;
        }

        // ส่ง email
        const emailData = {
          recipient: yachtOwnerEmail,
          subject: `New Booking No. [#${BookingNo}] | TakeMyYacht.com`,
          dear: yachtOwnerData?.name_yacht,
          firstName: bookingData.firstName,
          lastName: bookingData.lastName,
          email: bookingData.email,
          tel: bookingData.mobileNo,
          message: `
<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
<tr>
<td align="center">
<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="700" style="text-align: left; font-family: Arial, sans-serif; color: #333; background-color: #ffffff;">
<tr>
<td style="padding: 30px;">

<h2 style="color: #004080; margin-bottom: 10px;">📌 New Yacht Booking Inquiry Received</h2>

<p style="font-size: 15px; color: #555;">Dear ${yachtOwnerData?.name_yacht},</p>
<p style="font-size: 15px; color: #555;">A new yacht booking has been made. Please review the details below:</p>

<div style="background-color: #f0f6ff; border-left: 5px solid #004080; padding: 20px; margin: 20px 0; border-radius: 8px;">
<p style="margin: 5px 0;"><strong>Booking ID:</strong> ${idBooking}</p>
<p style="margin: 5px 0;"><strong>Booking NO:</strong> ${BookingNo}</p>
<p style="margin: 5px 0;"><strong>Guest Name:</strong> ${bookingData.guest_name
            }</p>
<p style="margin: 5px 0;"><strong>Email:</strong> ${bookingData.email}</p>
<p style="margin: 5px 0;"><strong>Phone:</strong> ${bookingData.mobileNo}</p>
<p style="margin: 5px 0;"><strong>Yacht Name:</strong> ${bookingData.yacht_name
            }</p>
<p style="margin: 5px 0;"><strong>Activity Type:</strong> ${bookingData.activity_type
            }</p>
<p style="margin: 5px 0;"><strong>Booking Date:</strong> ${bookingData.activity_date
            }</p>
<p style="margin: 5px 0;"><strong>Number of Passengers:</strong> Adults ${bookingData.adult
            }, Children ${bookingData.child}, Infants ${bookingData.infant}</p>
<p style="margin: 5px 0;"><strong>Total Price:</strong> ${totalPrice.toFixed(
              2,
            )} THB</p>
<p style="margin: 5px 0;"><strong>Booking Status:</strong> <span style="color:#e67e22; font-weight:bold;">${bookingData.status
            }</span></p>
</div>

<p style="font-size: 15px; color: #555;">Please confirm your availability using the options below:</p>

<div style="margin-top: 20px; text-align: center;">
<a href="https://takemyyacht.com/email-action?recipient=${yachtOwnerEmail}&email=${bookingData.email
            }&firstName=${bookingData.firstName}&lastName=${bookingData.lastName
            }&id_booking=${idBooking}&status=UNAVAILABLE&booking_no=${BookingNo}"
   style="display: inline-block; background-color: #ffffff; color: #d32f2f; border: 2px solid #d32f2f; padding: 12px 24px; border-radius: 6px; font-weight: bold; text-decoration: none; margin-right: 10px;">
     Occupied
</a>

<a href="https://takemyyacht.com/email-action?recipient=${yachtOwnerEmail}&email=${bookingData.email
            }&firstName=${bookingData.firstName}&lastName=${bookingData.lastName
            }&id_booking=${idBooking}&status=PENDING&booking_no=${BookingNo}"
   style="display: inline-block; background-color: #004080; color: white; border: 2px solid #004080; padding: 12px 24px; border-radius: 6px; font-weight: bold; text-decoration: none;">
    Vacant
</a>
</div>

<p style="margin-top: 40px; font-size: 14px; color: #555;">Best regards,<br/>TakeMyYacht Team</p>

</td>
</tr>
</table>
</td>
</tr>
</table>
`,
        };

        try {
          await dispatch(sendEmailBookingAction(emailData));
        } catch (error) {
          console.error("Failed to send email:", error);
        }
      }
    } catch (error) {
      console.error("Error creating booking:", error);
      showSnackbar(t("Error creating booking"), "error");
    }
  };

  const indexOfLastYacht = currentPage * yachtsPerPage;
  const indexOfFirstYacht = indexOfLastYacht - yachtsPerPage;
  const currentYachts = filteredYachts.slice(
    indexOfFirstYacht,
    indexOfLastYacht,
  );
  const totalPages = Math.ceil(filteredYachts.length / yachtsPerPage);

  return (
    <div>
      <img
        className="BoatHelm-1 mt-5vh"
        draggable={false}
        src={BoatHelm}
        alt="BoatHelm"
      />
      <h3>{t("Whitelist(s)")}</h3>
      <div className="yacht-list-wl">
        {currentYachts.length === 0 && (
          <div
            className="empty-state-message"
          >
            {t("No Whitelist Found")}
          </div>
        )}

        {currentYachts.map((yacht) => {
          const yachtDetail = yachtMap[yacht.id_yacht];
          const isFormOpen = openFormId === yacht.id_sellingPrice;
          const matchedPackage = allDestinationPackages.find(
            (pkg) =>
              Number(pkg.id_destination_package) ===
              Number(yacht.id_destination_package),
          );

          return (
            <div key={yacht.id_sellingPrice} className="yacht-card-wl">
              <div className="card-whitelist">
                <p className="whitelist-p">
                  {getLocalizedMarina(yacht.value_marina)}
                </p>
              </div>

              <div className="card-body-wl">
                <img
                  src={yacht.logo_yachtInfo_url}
                  alt={yacht.name_yacht_yachtInfo}
                  className="yacht-image-wl"
                />
                <div className="yacht-content-wl">
                  <div className="yacht-details-wl">
                    <h4>{yacht.name_yacht_yachtInfo}</h4>
                    <p>
                      <span role="img" aria-label="location">
                        <FaMapMarkerAlt />
                      </span>
                      <span className="marina-name-wl">
                        {getLocalizedMarina(yacht.value_marina)}
                      </span>
                    </p>
                    {yachtDetail && (
                      <p className="yacht-extra-wl">
                        {t("Operated by")} {yachtDetail.name_yacht}
                      </p>
                    )}
                  </div>
                  <div>
                    <button
                      className="booking-button-wl"
                      onClick={() => handleToggleForm(yacht.id_sellingPrice)}
                    >
                      {t("Booking Inquiry")}
                    </button>
                  </div>
                </div>
              </div>

              {isFormOpen && (
                <div
                  className="booking-form mt-3rem"
                >
                  <form onSubmit={(e) => handleSubmit(e, yacht)}>
                    {/* Contact Person */}
                    <div className="form-group row">
                      <label className="col-12 col-md-3 col-form-label text-left">
                        {t("Contact Person")} *
                      </label>
                      <div className="col-12 col-md-9">
                        <input
                          type="text"
                          className="form-control"
                          required
                          defaultValue={`${userDetails?.firstname || ""} ${userDetails?.lastname || ""
                            }`}
                          readOnly
                        />
                      </div>
                    </div>

                    {/* Mobile & Email */}
                    <div className="form-group row">
                      <label className="col-12 col-md-3 col-form-label text-left">
                        {t("Mobile Number")} *
                      </label>
                      <div className="col-12 col-md-3 mb-2 mb-md-0">
                        <input
                          type="tel"
                          className="form-control"
                          required
                          defaultValue={userDetails?.mobile_no || ""}
                          readOnly
                        />
                      </div>

                      <label className="col-12 col-md-2 col-form-label text-left">
                        {t("E-mail")} *
                      </label>
                      <div className="col-12 col-md-4">
                        <input
                          type="email"
                          className="form-control"
                          required
                          defaultValue={userDetails?.email || ""}
                          readOnly
                        />
                      </div>
                    </div>

                    {/* No. of Adults */}
                    <div className="form-group row">
                      <label className="col-12 col-md-3 col-form-label text-left">
                        {t("No. of Adult(s)")} *
                      </label>
                      <div className="col-12 col-md-9">
                        <div className="input-group">
                          <input
                            type="number"
                            name="adult"
                            className="form-control"
                            defaultValue={1}
                            min={1}
                            required
                            onKeyDown={(e) => {
                              if (["-", "e"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onInput={(e) => {
                              let value = e.target.value;
                              value = value.replace(/^0+/, "");
                              if (value === "" || parseInt(value) < 1) {
                                value = "1";
                              }
                              e.target.value = value;
                            }}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">{t("Pax")}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* No. of Child(s) */}
                    <div className="form-group row">
                      <label className="col-12 col-md-3 col-form-label text-left">
                        {t("No. of Child(s)")} *
                      </label>
                      <div className="col-12 col-md-9">
                        <div className="input-group">
                          <input
                            type="number"
                            name="child"
                            className="form-control"
                            defaultValue={0}
                            min={0}
                            required
                            onInput={(e) => {
                              let value = e.target.value;
                              if (value.length > 1) {
                                value = value.replace(/^0+/, "");
                              }
                              if (value === "") {
                                value = "0";
                              }
                              e.target.value = value;
                            }}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">{t("Pax")}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* No. of Infant(s) */}
                    <div className="form-group row">
                      <label className="col-12 col-md-3 col-form-label text-left">
                        {t("No. of Infant(s)")} *
                      </label>
                      <div className="col-12 col-md-9">
                        <div className="input-group">
                          <input
                            type="number"
                            name="infant"
                            className="form-control"
                            defaultValue={0}
                            min={0}
                            required
                            onInput={(e) => {
                              let value = e.target.value;
                              if (value.length > 1) {
                                value = value.replace(/^0+/, "");
                              }
                              if (value === "") {
                                value = "0";
                              }
                              e.target.value = value;
                            }}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">{t("Pax")}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Destination Package */}
                    <div className="form-group row">
                      <label className="col-12 col-md-3 col-form-label text-left">
                        {t("Destination Package")}
                      </label>
                      <div className="col-12 col-md-9">
                        <input
                          type="text"
                          className="form-control"
                          value={
                            matchedPackage
                              ? matchedPackage.name_destination_package
                              : "N/A"
                          }
                          readOnly
                        />
                      </div>
                    </div>

                    {/* Journey Category */}
                    <div className="form-group row">
                      <label className="col-12 col-md-3 col-form-label text-left">
                        {t("Journey Category")} *
                      </label>
                      <div className="col-12 col-md-9 pt-2">
                        <label className="mr-3">
                          <input
                            type="radio"
                            name={`journey-${yacht.id_sellingPrice}`}
                            value="Half Day"
                            defaultChecked={yacht.rate_type === "HalfDay"}
                            disabled
                          />{" "}
                          {t("Half Day")}
                        </label>
                        <label className="mr-3">
                          <input
                            type="radio"
                            name={`journey-${yacht.id_sellingPrice}`}
                            value="Day Trip"
                            defaultChecked={yacht.rate_type === "DayTrip"}
                            disabled
                          />{" "}
                          {t("DayTrip")}
                        </label>
                        <label className="mr-3">
                          <input
                            type="radio"
                            name={`journey-${yacht.id_sellingPrice}`}
                            value="Overnight"
                            defaultChecked={yacht.rate_type === "Overnight"}
                            disabled
                          />{" "}
                          {t("Overnight")}
                        </label>
                        <label className="ml-2">{t("Night(s)")}</label>
                      </div>
                    </div>

                    {/* Activity Date */}
                    <div className="form-group row">
                      <label className="col-12 col-md-3 col-form-label text-left">
                        {t("Activity Date")} *
                      </label>
                      <div className="col-12 col-md-9">
                        {yacht.rate_type === "Overnight" ? (
                          <div className="row">
                            <div className="col-12 col-md">
                              <label>{t("Start Date")}</label>
                              <input
                                type="date"
                                name="activity_start_date"
                                className="form-control"
                                required
                                min={today}
                                onChange={(e) => setStartDate(e.target.value)}
                              />
                            </div>
                            <div className="col-12 col-md">
                              <label>{t("End Date")}</label>
                              <input
                                type="date"
                                name="activity_end_date"
                                className="form-control"
                                min={startDate || today}
                                required
                              />
                            </div>
                          </div>
                        ) : (
                          <input
                            type="date"
                            name="activity_date"
                            className="form-control"
                            min={today}
                            required
                          />
                        )}
                      </div>
                    </div>

                    {/* Buttons */}
                    <div
                      className="form-group row justify-content-center mt-3rem"
                    >
                      <div className="col-auto">
                        <button
                          type="button"
                          className="btn-close-custom-wl mr-3"
                          onClick={() =>
                            handleToggleForm(yacht.id_sellingPrice)
                          }
                        >
                          {t("Close")}
                        </button>
                        <button type="submit" className="btn-submit-custom-wl">
                          {t("Submit")}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </div>
          );
        })}

        {totalPages > 1 && (
          <Pagination className="d-flex justify-content-center circular-pagination">
            <Pagination.Item
              className="prev"
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              &lt;
            </Pagination.Item>

            {Array.from({ length: totalPages }, (_, index) => index + 1)
              .filter((number) => {
                return (
                  number === 1 ||
                  number === totalPages ||
                  (number >= currentPage - 1 && number <= currentPage + 1)
                );
              })
              .reduce((acc, number, idx, arr) => {
                if (idx > 0 && number - arr[idx - 1] > 1) {
                  acc.push("ellipsis");
                }
                acc.push(number);
                return acc;
              }, [])
              .map((item, idx) =>
                item === "ellipsis" ? (
                  <Pagination.Ellipsis key={`ellipsis-${idx}`} disabled />
                ) : (
                  <Pagination.Item
                    key={item}
                    active={item === currentPage}
                    onClick={() => setCurrentPage(item)}
                  >
                    {item}
                  </Pagination.Item>
                ),
              )}

            <Pagination.Item
              className="next"
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              &gt;
            </Pagination.Item>
          </Pagination>
        )}
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          width: "auto",
        }}
      >
        <Alert
          sx={{
            borderRadius: 8,
          }}
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {loading && (
        <div
          className="fullscreen-overlay"
          aria-label="Loading"
          role="status"
        >
          <img
            src={Sail} // ถ้าใช้ไฟล์ใน public ให้เปลี่ยนเป็น "/Sail.gif"
            alt="Loading..."
            className="image-preview"
            draggable={false}
          />
        </div>
      )}
    </div>
  );
};

export default Whitelists;
